import { z } from "zod";

export const accountSchema = z.object({
  firstName: z.string().min(2, "First Name must be at least 2 characters"),
  lastName: z.string().optional(),
  phone: z.string().length(10, "Phone number must be exactly 10 digits").regex(/^\d+$/, "Phone number must contain only digits"),
  email: z.string().email("Invalid email address").optional().or(z.literal("")),
  address1: z.string().optional(),
  address2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  district: z.string().optional(),
  state: z.string().min(1, "State is required"),
  pincode: z.string().length(6, "PIN code must be 6 digits").regex(/^\d+$/, "PIN code must be numeric").optional().or(z.literal("")),
  officeLocation: z.string().min(1, "Office Location is required"),
  requirementType: z.string().optional(),
  propertyType: z.string().optional(),
  budget: z.string().optional().or(z.number()).transform(val => (val === "" || val === undefined ? 0 : Number(val))),
  notes: z.string().optional(),
  source: z.string().default("Direct"),
  referenceType: z.string().optional(),
  referenceDetails: z.string().optional(),
  assignedTo: z.string().optional(),
});
